export class CustomerAddressChild {
    public recID: number = 0;
    public lastName: string = '';
    public firstName: string = '';
    public middleName: string = '';
    public parentRecID: number = 0;
    public editing: boolean = false;
}
